import $ from 'jquery'
import { revalidate as revalidateLazyload } from './lazyload'
import cities from './constants/cities'
import { saveToLocalStorage, loadFromLocalStorage } from './utils/localStorageUtils'
import { isLight } from './utils/colorUtils'
import { initSections as initWeatherOverviewSections } from './weather-overview'
import { fetchAll, getCityNames, getCurrentCity, getCurrentCityName } from './weather'

const $weather = $('[data-local-weather]')
const $buttons = $('[data-toolbox-buttons]')
const $showAll = $buttons.find('[data-toolbox-show-all]')
const $hideAll = $buttons.find('[data-toolbox-hide-all]')
const $activityTilesContainer = $('.activity-tiles:not([data-static])')
let $activityTiles = $('.activity-tiles:not([data-static]) .activity-tile')

const timeZoneCities = {
  'Australia/Brisbane': [
    'Airlie Beach',
    'Brisbane',
    'Cairns',
    'Gold Coast',
    'Toowoomba',
    'Townsville',
    'Sunshine Coast',
    'Rockhampton',
    'Yatala',
  ],
  'Australia/Melbourne': ['Melbourne', 'Hobart', 'Geelong'],
  'Australia/Sydney': ['Sydney', 'Newcastle', 'Wollongong'],
  'Australia/Adelaide': ['Darwin', 'Adelaide'],
  'Australia/Perth': ['Perth'],
}

const ajaxCallbacks = []

export function addCallback(func) {
  ajaxCallbacks.push(func)
}

function deg2rad(deg) {
  return deg * (Math.PI / 180)
}

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371 // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1) // deg2rad below
  const dLon = deg2rad(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c // Distance in km
  return d
}

export let loadedLocation = false
export let loadedWeather = false
export let location = loadFromLocalStorage('location', {})
export let cityWeather = []
// let activities = [];
export let closestCity = {}
export let weather = {}
export let cityPreference = loadFromLocalStorage('city', '')

export const fetchLocation = () => {
  if (Object.keys(location).length > 0) {
    loadedLocation = true
    return $.Deferred().resolve(true)
  } else {
    return $.ajax('/toolbox/get_location.json', {
      dataType: 'json',
      success: (data, status, xhr) => {
        loadedLocation = true
        location = data.location
        saveToLocalStorage('location', location)
      },
    })
  }
}

export const fetchWeatherOverview = () => {
  if (loadedWeather) {
    return $.Deferred().resolve(true)
  } else {
    return $.ajax('/toolbox/australia_overview.json', {
      dataType: 'json',
      success: (data, status, xhr) => {
        loadedWeather = true
        cityWeather = data.data
        ajaxCallbacks.forEach((func) => func())
      },
    })
  }
}

export const addDistKeyToLocations = (locations = [], lat, lon, getCoord = (val) => val) =>
  locations.map((location) =>
    Object.assign({}, location, {
      dist: getDistanceFromLatLonInKm(lat, lon, getCoord(location).lat, getCoord(location).lon),
    })
  )

export const getClosestCity = (cities = []) => cities.sort((a, b) => a.dist - b.dist)[0]

export const calcClosestCityAndWeather = () => {
  if (!selectCity(cityPreference)) {
    const latLon = location.loc.split(',').map((num) => parseFloat(num))
    closestCity = getClosestCity(addDistKeyToLocations(cities, latLon[0], latLon[1]))
    weather = getClosestCity(addDistKeyToLocations(cityWeather, latLon[0], latLon[1], (city) => city.coord))
  }
  return $.Deferred().resolve(true)
}

export function init() {
  if (!$('.activity-tiles .activity-tile').length) return

  let $citySelectors = null
  fetchAll().then(() => {
    displayActivities()
    $citySelectors = createCitySelect()
  })

  $(document).on('cityChange', () => {
    displayActivities()
    if ($citySelectors) {
      $citySelectors.each((i, el) => {
        const $citySelector = $(el)
        $citySelector.off('change')
        $citySelector.val(getCurrentCity().name)
        $citySelector.on('change', () => displayActivities($citySelector.val()))
      })
    }
  })

  $('.activity-tiles .activity-tile').each((i, elem) => {
    const $tileBody = $(elem).find('.activity-body')
    if ($tileBody.hasClass('text-auto')) {
      const hasMedia = $tileBody.hasClass('has-media')
      const background = $(elem).find('.activity-inner').css('background-color')
      const rgb = background.replace(/[^\d,.]/g, '').split(',')
      if (!hasMedia && isLight(rgb)) {
        $tileBody.addClass('dark-text')
      }
    }
  })

  $('.activity-card-header').each((i, elem) => {
    const background = $(elem).css('background-color')
    const rgb = background.replace(/[^\d,.]/g, '').split(',')
    if (isLight(rgb)) $(elem).addClass('dark-text')
  })
}

function createCitySelect() {
  const cities = getCityNames()
  const selects = []
  $('[data-activities-location-selector]').each((i, el) => {
    const $select = buildSelect(cities)
    $select.val(getCurrentCity().name)
    $select.on('change', () => displayActivities($select.val()))
    $(el).append($select)
    selects.push($select)
  })
  return $(selects)
}

function buildSelect(options) {
  return $(`<select>${options.map((v) => `<option value="${v}">${v}</option>`).join('')}</select>`)
}

export const getPriority = (code) => {
  if (
    (code >= 200 && code <= 232) || // thunderstorms
    (code >= 502 && code <= 511) || // heavy rain
    [511, 522, 959].indexOf(code) >= 0 // intense rain
  )
    return 'warning'

  if (
    (code >= 600 && code <= 622) || // snow
    (code >= 900 && code <= 902) || // tornado, tropical storm, hurricane
    (code >= 960 && code <= 962) || // storm, violient storm, hurricane
    [906, 731, 751, 762, 781].indexOf(code) >= 0 // misc scary atmospheres
  )
    return 'alert'

  return 'fine'
}

function selectCity(cityName) {
  weather = cityWeather.filter((city) => city.name === cityName)[0]
  if (!weather) return false
  closestCity = cities
    .map((city) =>
      Object.assign({}, city, {
        dist: getDistanceFromLatLonInKm(weather.coord.lat, weather.coord.lon, city.lat, city.lon),
      })
    )
    .sort((a, b) => a.dist - b.dist)[0]
  return true
}

export const getForecastTimeString = (cityName) => {
  const date = new Date()
  return new Intl.DateTimeFormat('en-AU', {
    hour12: true,
    hour: 'numeric',
    minute: 'numeric',
    timeZone: getTimezoneFromCityString(cityName),
    timeZoneName: 'short',
  }).format(date)
}

export const getTemperatureString = (temp_min, temp_max) => {
  const tempMin = Math.round(temp_min * 10) / 10
  const tempMax = Math.round(temp_max * 10) / 10
  const tempRangeString = tempMin + '&deg;C' + (tempMin != tempMax ? ' - ' + tempMax + '&deg;C' : '')
  return tempRangeString
}

export const getTimezoneFromCityString = (cityName) =>
  Object.keys(timeZoneCities).reduce((val, code) => (timeZoneCities[code].indexOf(cityName) >= 0 ? code : val), null)

function displayMessage() {
  const { id, icon, description } = weather.weather[0] || {}
  const { temp_min, temp_max } = weather.main

  const weatherPriority = getPriority(id)
  const forecastString = getForecastTimeString(weather.name)
  const tempRangeString = getTemperatureString(temp_min, temp_max)

  let cityDropdown = ''
  for (let city of cityWeather) {
    const selected = city.name === weather.name ? ' selected' : ''
    cityDropdown += '<option value="' + city.name + '"' + selected + '>&nbsp;&nbsp;' + city.name + '</option>'
  }
  cityDropdown = '<div class="selector"><select>' + cityDropdown + '</select></div>'

  const urlOverride = $weather.data('weather-url')
  let title = cityDropdown
  title += `<a href="${urlOverride ? urlOverride : closestCity.bom}" target="${urlOverride ? '_self' : '_blank'}">`
  title += `<span>${forecastString} /&nbsp;</span>`
  title += `<span>${tempRangeString} /</span> `
  title += `<span class="text-${weatherPriority == 'alert' ? 'error' : weatherPriority}">${description}</span>`
  title += `</a>`

  const $img = $('<img />')
  $img.get(0).onload = () => $img.animate({ opacity: 1 }, 'fast')
  $img.attr('src', 'https://openweathermap.org/img/w/' + icon + '.png').css('opacity', 0)

  $weather.hide().html(title).slideDown('slow')
  $img.appendTo($weather.find('a'))

  $weather.find('select').on('change', (event) => {
    selectCity(event.target.value)
    saveToLocalStorage('city', event.target.value)
    // fetchActivities(weather ? weather.name : false)
    displayActivities()
    displayMessage()
    initWeatherOverviewSections()
    revalidateLazyload()
  })
}

$showAll.on('click', () => {
  saveToLocalStorage('hidden_activities', [])
  displayActivities()
  setTimeout(() => displayActivities(), 200)
})

$hideAll.on('click', () => {
  let hiddenActivities = loadFromLocalStorage('hidden_activities', [])

  hiddenActivities = [
    ...hiddenActivities,
    ...visibleActivityIds.map((id) => ({ id, time: new Date().getTime() / 1000 })),
  ]
  saveToLocalStorage('hidden_activities', hiddenActivities)

  setTimeout(() => displayActivities(), 200)
  $activityTiles.each((i, elem) => {
    if (visibleActivityIds.indexOf($(elem).data('activity-id')) >= 0) $(elem).slideUp('fast')
  })
})

let hiddenActivityIds = []
let visibleActivityIds = []
let activeActivityIds = []
let inactiveActivityIds = []

function updateActivityStores(overrideCityName = null) {
  hiddenActivityIds = []
  visibleActivityIds = []
  activeActivityIds = []
  inactiveActivityIds = []

  let hiddenActivities = loadFromLocalStorage('hidden_activities', [])

  const allHiddenActivityIds = hiddenActivities.map(({ id }) => id)
  const cityName = overrideCityName || getCurrentCityName()

  // remove old hidden items after a day
  const currentTime = new Date().getTime() / 1000
  const dayLength = 24 * 60 * 60
  hiddenActivities = hiddenActivities.filter((item) => currentTime - item.time < dayLength)
  saveToLocalStorage('hidden_activities', hiddenActivities)

  // iterate over elements to display/hide
  $activityTiles.each((i, elem) => {
    const activityId = $(elem).data('activity-id')
    const allCities = $(elem).data('all-cities')
    const cities = $(elem).data('activity-cities')
    const $hideButton = $(elem).find('[data-activity-hide]')

    $hideButton.off('click').on('click', (e) => {
      console.log('HIDE PLS')
      e.preventDefault()
      hiddenActivities.push({ id: activityId, time: new Date().getTime() / 1000 })
      saveToLocalStorage('hidden_activities', hiddenActivities)
      $(elem).slideUp('fast', () => {
        $(elem).closest('.slick-slide').hide()

        displayActivities()

        $(elem).closest('[data-gallery]').slick('slickGoTo', 0)

        // const tempActiveIds = visibleActivityIds.filter(id => id != activityId)
        // if(tempActiveIds.length > 0) $(`[activity-id="${tempActiveIds[0]}"]`).closest('')

        // const $slide = $(elem).closest('.slick-slide:visible');
        // $slide.closest('[data-gallery]').slick('slickGoTo', $slide.index());
      })
    })

    const active = !cityName || allCities || (cityName && cities.indexOf(cityName) >= 0)
    const hidden = allHiddenActivityIds.indexOf(activityId) >= 0

    if (active) {
      activeActivityIds.push(activityId)
      if (hidden) hiddenActivityIds.push(activityId)
      else visibleActivityIds.push(activityId)
    } else {
      inactiveActivityIds.push(activityId)
    }
  })
}

let inited = false

function displayActivities(overrideCityName = null) {
  updateActivityStores(overrideCityName)

  $showAll.addClass('hide')
  $hideAll.addClass('hide')
  $buttons.removeClass('collapse-bottom')

  // $('.activity-tiles[data-activities-gallery]').slick('slickUnfilter');

  // $('.activity-tiles[data-activities-gallery]').slick('slickFilter', (i, elem) => {
  // 	const id = $(elem)
  // 		.find('[data-activity-id]')
  // 		.data('activity-id');
  // 	return visibleActivityIds.indexOf(id) >= 0;
  // });

  $activityTiles.each((i, elem) => {
    if (visibleActivityIds.indexOf($(elem).data('activity-id')) >= 0) {
      if ($(elem).is(':hidden')) {
        $(elem).closest('.slick-slide').show()
        if (!inited) {
          $(elem).removeClass('hide')
        } else {
          $(elem).removeClass('hide').hide().slideDown()
        }
      }
    } else {
      $(elem).hide()
      $(elem).closest('.slick-slide').hide()
    }
  })

  inited = true

  if (hiddenActivityIds.length > 0) $showAll.removeClass('hide')
  if (visibleActivityIds.length > 0) {
    $hideAll.removeClass('hide')
    $activityTilesContainer.find('.slide-control').show()
    $activityTilesContainer.find('.slick-list').css({ height: 'auto' })
  } else {
    $activityTilesContainer.find('.slide-control').hide()
    $activityTilesContainer.find('.slick-list').css({ height: 'auto' })
  }

  if (!visibleActivityIds.length) $activityTilesContainer.removeClass('padding-bottom-medium')
  else if (!$activityTilesContainer.hasClass('padding-bottom-medium'))
    $activityTilesContainer.addClass('padding-bottom-medium')
}
